<template>
  <SoupBody />
</template>

<script>
import SoupBody from '../molecules/SoupBody.vue'


export default {
  name: 'SoupView',
  components: {
    SoupBody,
  }
}
</script>
